// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","wrapper":"Footer_wrapper__RAsdB","logo":"Footer_logo__w79hm","year":"Footer_year__8BxLY"};